import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

import "../../../styles/layouts/header/_headerCategoriesNavLinksComponent.scss";
import useMobileScreen from "../../../hooks/useMobileScreen";
import useAccount from "../../../hooks/useAccount";

// 0015: categories are now fetched ONCE in <AppBootstrap/> (React Query) and bridged into Redux.
// This component only READS state.categoryReducer.categories — no fetch trigger here anymore.
export const HeaderCategoriesNavLinksComponent = ({ props, categories }) => {
  const navigation = useNavigate();
  const { toggleOpenNavMenu } = props;
  const { isLoggedIn, userInfo } = useAccount();

  // const [categories, setCategories] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [isSubMenuHovered, setIsSubMenuHovered] = useState(false);
  const isMobileScreen = useMobileScreen();

  const handleMouseEnterParent = (categoryId) => {
    if (isMobileScreen) return;
    setActiveCategoryId(categoryId);
  };

  const handleMouseEnterSubMenu = () => {
    if (isMobileScreen) return;
    setIsSubMenuHovered(true);
  };

  const handleMouseLeaveSubMenu = () => {
    if (isMobileScreen) return;
    setIsSubMenuHovered(false);
    setActiveCategoryId(null);
  };

  const handleCategoryLinkClick = () => {
    if (isMobileScreen === false) return;
    toggleOpenNavMenu();
  };

  const handleParentCategoryLinkClick = (categoryId, itemGroups) => {
    if (!itemGroups || itemGroups.length <= 0) {
      navigation(`/categories/${categoryId}`);

      if (isMobileScreen) toggleOpenNavMenu();

      return;
    }

    if (isMobileScreen === false) return;
    setActiveCategoryId((prevActiveCategoryId) => (prevActiveCategoryId === categoryId ? null : categoryId));
  };

  const getAllItemsNavElement = () => {
    return (
      <Link to={`items`} className="parentCategoryLink" onClick={handleCategoryLinkClick}>
        כל המוצרים
      </Link>
    );
  };

  const renderItemGroups = (categoryId, itemGroups) => {
    return itemGroups.map((itemGroup) => (
      <Link key={itemGroup.id} to={`/categories/${categoryId}/itemGroup/${itemGroup.id}`} className="subcategoryLink">
        <div
          onClick={handleCategoryLinkClick}
          className="subcategoryImage"
          style={{
            backgroundImage: `url(${itemGroup.pictureUrl || ""})`,
            backgroundSize: "cover",
          }}
        >
          <span>{itemGroup.itemGroupName}</span>
        </div>
      </Link>
    ));
  };

  const renderItemGroups_Mobile = (categoryId, itemGroups) => {
    const shouldRenderSubCategories = activeCategoryId === categoryId && itemGroups.length > 0;
    return (
      shouldRenderSubCategories && (
        <div className="subCategoriesContainer_Mobile" onClick={handleCategoryLinkClick}>
          {itemGroups.map((itemGroup) => (
            <Link key={itemGroup.id} to={`/categories/${categoryId}/itemGroup/${itemGroup.id}`}>
              {itemGroup.itemGroupName}
            </Link>
          ))}
        </div>
      )
    );
  };

  const getItemGroupsElement = (categoryId, itemGroups) => {
    if (isMobileScreen) return renderItemGroups_Mobile(categoryId, itemGroups);
    else {
      const shouldRenderSubCategories = activeCategoryId === categoryId && itemGroups.length > 0;
      if (!shouldRenderSubCategories) return null;
      return (
        <div className="subCategoriesContainer" onMouseEnter={handleMouseEnterSubMenu} onMouseLeave={handleMouseLeaveSubMenu}>
          {renderItemGroups(categoryId, itemGroups)}
        </div>
      );
    }
  };

  const renderCategories = (category) => {
    return (
      <div key={category.id} className="parentCategoryContainer" onMouseEnter={() => handleMouseEnterParent(category.id)} onClick={() => handleParentCategoryLinkClick(category.id, category.itemGroups)}>
        <div className="parentCategoryLink">
          <span>{category.categoryName}</span>
          {isMobileScreen && getSubCategoryArrowIcon(category.id, category.itemGroups)}
        </div>
        {getItemGroupsElement(category.id, category.itemGroups)}
      </div>
    );
  };

  const getSubCategoryArrowIcon = (categoryId, itemGroups) => {
    if (!itemGroups || itemGroups.length === 0) return null; // Don't show anything if there are no itemGroups
    const shouldRenderSubCategories = activeCategoryId === categoryId;
    return shouldRenderSubCategories ? <i className="fa-solid fa-sort-up"></i> : <i className="fa-solid fa-sort-down"></i>;
  };

  const getDashboardLinkElement = () => {
    if (isLoggedIn && userInfo?.id && userInfo.userType === "Administrator")
      return (
        <Link to={`/admin/dashboard/${userInfo.id}`} className="parentCategoryLink" onClick={handleCategoryLinkClick}>
          איזור אישי
        </Link>
      );
    else if (isLoggedIn && userInfo?.id && userInfo.userType === "Business")
      return (
        <Link to={`/business/dashboard/${userInfo.id}`} className="parentCategoryLink" onClick={handleCategoryLinkClick}>
          איזור אישי
        </Link>
      );
    else if (isLoggedIn && userInfo?.id && userInfo.userType === "Agent")
      return (
        <Link to={`/agent/dashboard/${userInfo.id}`} className="parentCategoryLink" onClick={handleCategoryLinkClick}>
          איזור אישי
        </Link>
      );
  };

  if (!categories || !categories.items) return null;

  return (
    <div className="categoriesLinksContainer">
      {getAllItemsNavElement()}
      {categories.items.map((category) => renderCategories(category))}
      {getDashboardLinkElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.categories, // Subscribe to categories state from the reducer
});

export default connect(mapStateToProps)(HeaderCategoriesNavLinksComponent);